import { render, staticRenderFns } from "./ImportanceSelector.vue?vue&type=template&id=00a7091e"
import script from "./ImportanceSelector.vue?vue&type=script&lang=js"
export * from "./ImportanceSelector.vue?vue&type=script&lang=js"
import style0 from "./ImportanceSelector.vue?vue&type=style&index=0&id=00a7091e&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports